import { gql } from "@apollo/client";

const GET_CLIENT_STATISTICS = gql`
  query getClientStatistics($clientIdentifier: String!) {
    client(clientIdentifier: $clientIdentifier) {
      id
      identifier
      name
      invoicesStatistics {
        activeInvoicesCount
        activeInvoicesValue
        clientBalance
        depositBalance
        escrowLimit
        escrowValue
        ongoingCasesCount
        todaysPayoutAmount
        maturityStructure {
          overdueByCurrency {
            currencyCode
            numberOfInvoicesOverdue
            totalAmountIncludingVatOutstanding
            totalAmountIncludingVatOverdue
          }
          brackets {
            daysOverdueThreshold
            numberOfInvoices
            totalAmountIncludingVatOverdue
          }
        }
      }
      limits {
        financialLimit {
          limit
          used
        }
        recipientLimit {
          limit
          used
        }
        repurchaseLimit {
          limit
          used
        }
      }
      creditData {
        creditRating {
          creditLimit
        }
        negativeInformation {
          debtBalance {
            totalBalance
            currency
          }
          recordOfNonPayment {
            numberOfApplications
          }
        }
      }
    }
  }
`;

export default GET_CLIENT_STATISTICS;
